module.exports = __webpack_public_path__ + "img/1.cc1d610f.jpg";